import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import IntersectionObserver from '@researchgate/react-intersection-observer';

import { sendEventClick } from 'src/api/tracker';

import getOffers from 'src/redux/actions/offers';

import JobAlert from 'src/components/JobAlert';
import PaginationWrapper from 'src/components/Pagination/PaginationWrapper';
import RedirectionToAddingJobAlert from 'src/components/RedirectionToAddingJobAlert';
import SeeAll from 'src/components/SeeAll';

import 'src/containers/JobAlertsContainer.scss';

const renderTitle = () => {
  const titleText = 'Zapisane wyszukiwania (JobAlerty)';

  return <h2 styleName="headline__title">{titleText}</h2>;
};

const renderPagination = (jobAlerts) => (
  <PaginationWrapper>
    {jobAlerts.map(({ id, name, offers, criterias, active }, index) => (
      <JobAlert
        key={id}
        {...{
          name,
          offers,
          criterias,
          active,
        }}
        onJobAlertClick={() => sendEventClick('savedSearch', index)}
      />
    ))}

    <div styleName="job-alerts-additional-box">
      <RedirectionToAddingJobAlert />
    </div>
  </PaginationWrapper>
);

const JobAlerts = ({ jobAlerts, dispatch }) => {
  const displayLimit = 3;
  const activeJobAlertsToDisplay = jobAlerts
    .filter(({ active }) => active)
    .splice(0, displayLimit);

  const loadCounters = ({ intersectionRatio }, unobserve) => {
    if (intersectionRatio) {
      unobserve();
      activeJobAlertsToDisplay.map(({ criterias, id }) =>
        dispatch(getOffers({ criterias, id }))
      );
    }
  };

  return (
    <div data-test="section-job-alerts" styleName="box">
      <div styleName="job-alerts">
        <div styleName="job-alerts__headline headline">
          {renderTitle()}
          {jobAlerts.length > 0 && <SeeAll jobAlerts={jobAlerts.length} />}
        </div>

        <IntersectionObserver onChange={loadCounters}>
          {renderPagination(activeJobAlertsToDisplay)}
        </IntersectionObserver>
      </div>
    </div>
  );
};

JobAlerts.propTypes = {
  dispatch: PropTypes.func.isRequired,
  jobAlerts: PropTypes.arrayOf(
    PropTypes.shape({
      criterias: PropTypes.objectOf(PropTypes.string.isRequired).isRequired,
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      offers: PropTypes.number,
    }).isRequired
  ).isRequired,
};

const mapStateToProperties = (state) => ({
  jobAlerts: state.jobAlertsReducer.jobAlerts,
});

export default connect(mapStateToProperties)(JobAlerts);

export { JobAlerts };
